import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const FormWrapper = styled.form`
  max-width: 434px;
  margin: 105px auto;
`;

export const ButtonSend = styled(Button)`
  margin: 0 auto;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
`;

export const TermsAndConditions = styled.p`
  font-size: 11px;
  margin-left: 8px;

  a {
    color: ${COLORS.BLUE_LINK};
    font-family: ${FONTS.ROBOTO_BOLD};
    text-decoration: underline;
    font-size: 11px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;

    a {
      font-size: 13px;
    }
  }
`;

export const ButtonGoBack = styled.a`
  left: 0;
  font-size: 15px;
  font-family: ${FONTS.ROBOTO_BOLD};
  color: ${COLORS.BLACK_BOLD};
  display: flex;
  margin-left: 15px;
  margin-top: 15px;

  svg {
    margin-right: 4px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
    position: absolute;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;